/**
 * Parse ahoy: URI scheme for CRM entity links.
 *
 * Format: ahoy:{type}:{id}
 * - type: 'contact' or 'company'
 * - id: UUID in format 8-4-4-4-12 (lowercase hex digits)
 *
 * @param href - URI string to parse
 * @returns Parsed URI with type and id, or null if invalid
 *
 * @example
 * parseAhoyUri('ahoy:contact:123e4567-e89b-12d3-a456-426614174000')
 * // Returns: { type: 'contact', id: '123e4567-e89b-12d3-a456-426614174000' }
 *
 * @example
 * parseAhoyUri('ahoy:company:invalid-id')
 * // Returns: null (not a valid UUID)
 *
 * @example
 * parseAhoyUri('https://example.com')
 * // Returns: null (not an ahoy: URI)
 */
export function parseAhoyUri(
  href: string | undefined
): { type: 'contact' | 'company'; id: string } | null {
  if (typeof href !== 'string') {
    return null;
  }

  // Enforce UUID format: 8-4-4-4-12 hex digits
  const match = href.match(
    /^ahoy:(contact|company):([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})$/i
  );
  if (!match) {
    return null;
  }

  const [, type, id] = match;
  return { type: type.toLowerCase() as 'contact' | 'company', id };
}
